import { Injectable } from '@angular/core';
import { BinaryWriter } from 'google-protobuf';
import { Group } from '../../../libs/proto/commUnity_pb';

@Injectable({
  providedIn: 'root'
})
export class GroupConversionService {

  ToStorage(req: Group) {
    const w = new BinaryWriter();
    Group.serializeBinaryToWriter( req, w);

    const abuf = w.getResultBuffer();
    return Array.from // if available
              ? Array.from(abuf) // use Array#from
              : abuf.map(v => v);
  }

  FromStorage(data: any, callback: (Group: Group, errorConvert: any) => void) {
    try {
      callback( Group.deserializeBinary(data), null);
    } catch (error) {
      callback( null, error);
    }
  }

  ToStorages(Group: Group[]) {
    const rets = new Array<Uint8Array | number[]>();

    Group.forEach(element => {
      rets.push(
        this.ToStorage(element)
      );
    });

    return {data: rets};
  }

  FromStorages(data: any, callback: (Group: Group[], errorConvert: any) => void) {
    if (data == null) {
      callback(null, Error('empty'));
      return;
    }
    const emps = new Array<Group>();
    const empjs: {data: (Uint8Array)[]} = data;
    try {

      empjs.data.forEach(element => {
        const emp = Group.deserializeBinary( element  );
        emps.push ( emp );
      });

      callback( emps, null);
    } catch (error) {
      callback( null, error);
    }
  }
}

